<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <zv-table :table="table" ref="dataTable">
          <div slot="ctrl-button">
            <el-button type="primary" @click="doAdd()">新增采集源</el-button>
          </div>
        </zv-table>

        <zv-dialog
          width="400px"
          :title="isEdit ? '修改采集源' : '新增采集源'"
          :showDialog.sync="showFormDialog"
          @close-dialog="closeFormDialog"
        >
          <div slot="content">
            <el-form
              ref="myForm"
              label-width="140px"
              :model="formData"
              :rules="formRules"
              status-icon
            >
              <el-form-item label="采集源名称：" prop="name">
                <el-input v-model="formData.name" clearable></el-input>
              </el-form-item>
              <el-form-item label="资讯分类：" prop="cat_id">
                <el-select
                  v-model="formData.cat_id"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in $enums.CollectSourceType.list"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="国家：" prop="area_id">
                <el-select
                  v-model="formData.area_id"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in countryList"
                    :key="item.id"
                    :label="item.area_name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="语言：" prop="lan_id">
                <el-select
                  v-model="formData.lan_id"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in languageList"
                    :key="item.id"
                    :label="item.language"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="采集源网址：">
                <el-input v-model="formData.url_prefix" clearable></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="btns">
            <el-button @click="showFormDialog = false">取消</el-button>
            <el-button type="primary" @click="submitForm">确定</el-button>
          </div>
        </zv-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import baseApi from "@/api/baseApi";
import dataAnalysisApi from "@/views/data-analysis/api";
import api from "./api";
import TipUtil from "@/utils/utils/TipUtil";
import addFormMixin from "@/mixins/addFormMixin";
export default {
  name: "AppList",
  mixins: [addFormMixin],
  components: {
  },
  data() {
    let vm = this;
    return {
      table: {
        api: api.collectSourceList,
        query: {
        
        },
        searchData: [
          {
            type: "input",
            model: "name",
            placeholder: "采集源名称"
          },
          {
            type: "select",
            model: "cat_id",
            placeholder: "资讯分类",
            option: this.$enums.CollectSourceType.list
          },
          {
            type: "select",
            model: "lan_id",
            placeholder: "语言类型",
            api: baseApi.getCollectLanguageList,
            keyValueName: ["id", "language"]
          }, {
            type: "select",
            model: "area_id",
            placeholder: "国家",
            api: dataAnalysisApi.areaList,
            query: {
              page: 1,
              pagesize: vm.$enums.allPageSize,
              area_type: 2
            },
            keyValueName: ["id", "area_name"]
          }
        ],
        // customSearchData: [{
        //   type: "select",
        //   model: "lan_id",
        //   placeholder: "语言类型",
        //   api: baseApi.getCollectLanguageList,
        //   keyValueName: ["id", "language"]
        // }, {
        //   type: "select",
        //   model: "area_id",
        //   placeholder: "国家",
        //   api: dataAnalysisApi.areaList,
        //   query: {
        //     page: 1,
        //     pagesize: vm.$enums.allPageSize,
        //     area_type: 2
        //   },
        //   keyValueName: ["id", "area_name"]
        // }],
        columns: [
          {
            title: "采集源名称",
            key: "name",
            minWidth:"250",
            showTooltip: true
          },
          {
            title: "资讯分类",
            key: "cat_id",
            minWidth:"150",
            showTooltip: true,
            render(h, ctx) {
              let type = ctx.row.cat_id
              let retStr = vm.$enums.CollectSourceType.getName(type)

              return h("div", retStr || '--');
            }
          },
          {
            title: "国家",
            key: "area_name",
            minWidth:"150",
            showTooltip: true
          },
          {
            title: "语言类型",
            key: "language",
            minWidth:"150",
            showTooltip: true
          },
          {
            title: "网址",
            key: "url_prefix",
            minWidth:"150",
            showTooltip: true,
            render(h, ctx) {
              return h(
                "a",
                {
                  attrs: {
                    target: '_blank',
                    href: ctx.row.url_prefix
                  }
                },
                ctx.row.url_prefix
              );
            }
          },
          {
            title: "操作人",
            key: "last_admin_username",
            minWidth: "60",
            render(h, ctx) {
              let status = ctx.row.last_admin_username;
              let statusText;
              if (status == "") {
                statusText = "--";
              } else {
                statusText = status;
              }
              return h("span", statusText);
            }
          },
          {
            title: "操作",
            fixed: "right",
            minWidth:"150",
            render(h, ctx) {
              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doEdit.bind(this, ctx.row)
                  }
                },
                "修改"
              );

              const delBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {

                    click: vm.doDelete.bind(this, ctx.row.id)
                  }
                },

                "删除"
              );

              let arr = [];
              arr.push(editBtn);

              arr.push(delBtn);

              return h("span", arr);
            }
          }
        ]
      },
      formDataOri: {
        name: ''
      },
      formRules: {
        name: {
          required: true,
          message: "采集源名称不能为空",
          trigger: "blur"
        },
        cat_id: {
          required: true,
          message: "资讯分类不能为空",
          trigger: "change"
        },
        area_id: {
          required: true,
          message: "国家不能为空",
          trigger: "change"
        },
        lan_id: {
          required: true,
          message: "语言不能为空",
          trigger: "change"
        },
        url_prefix: [{
          required: true,
          message: "网址不能为空",
          trigger: "blur"
        }, {
          type: 'url',
          message: "网址格式不正确，请输入正确的网址",
          trigger: "blur"
        }]
      },
      adddApi: api.addCollectSource,
      editApi: api.editCollectSource,
      deleteApi: api.deleteCollectSource,
      addSuccessMsg: '添加采集源成功',
      editSuccessMsg: '编辑采集源成功',
      deleteSuccessMsg: '删除采集源成功',
      countryList: [],  // 国家列表
      languageList: [],  // 语言列表
    };
  },

  computed: {

  },

  methods: {
  },

  created() {
    // 获取国家信息
    this.$commFunc.getAreaList({area_type: 2}).then(res => {
      this.countryList = res
    })

    this.$commFunc.getCollectLanguageList().then(res => {
      this.languageList = res
    })
  },

  mounted() {

  },
  beforeDestroy() {

  }
};
</script>

<style lang="less" scoped>

</style>
